import React from "react";

function AboutMe() {
  return (
    <section className="about-section">
      <div className="left my-4">
        <h1>ABOUT ME</h1>
      </div>

      <div className="about-container">

        <div className="about-card">

          <p className="about-highlight">
            Software Engineer with <b>3+ years of experience</b> in 
            <b> Python, Django, and React</b>, building enterprise systems and 
            scalable web applications. Currently working in the 
            <b> Capital Markets domain</b> on the <b>TCS BaNCS platform</b>.
          </p>

          <p>
            I have worked extensively on <b>settlement, cash, and pricing workflows</b>,
            production issue resolution, workflow enhancements, and 
            <b> financial messaging systems</b> involving <b>SWIFT MT</b> and 
            <b> ISO 20022 standards</b>.
          </p>

          <p>
            Beyond enterprise systems, I build <b>AI-powered and full-stack
            applications</b> across web, mobile, and cloud platforms. My work
            includes intelligent search systems, multimodal AI storytelling
            platforms, creative production engines, and personal growth apps
            using modern technologies.
          </p>

          <p>
            My technology stack includes <b>Django, DRF, React, Next.js,
            React Native, PostgreSQL, Docker, and Google Cloud</b>.  
            I enjoy building impactful products at the intersection of <b>AI, fintech, and scalable user experiences</b>.
          </p>

        </div>

      </div>
    </section>
  );
}

export default AboutMe;